<template>
  <main class="login-box portal-login"><div class="login-container">
    <section class="login-info"><h2>Добро пожаловать в личный кабинет BS CRM</h2><p>Договоры, документы и результаты работы по вашим проектам.</p><ul class="features"><li>Действующие договоры</li><li>Отчёты и выполненные работы</li><li>Документы и сроки действия доменов</li></ul></section>
    <section class="login-form"><router-view /></section>
  </div></main>
</template>
